/**
 * Provides JS functionality for tracking alert display.
 */
export class ExpandingCards extends DrupalBehavior {
  onContent(context) {
    const toggles = $(once('toggle', '.expanding-card--toggle', context));
    toggles.each(function () {
      $(this).on('click', (e) => {
        e.preventDefault();
        let $card = $(this).parent().parent();
        $card.toggleClass('open');
        let $content = $card.find('.expanding-card--hidden');
        if ($card.hasClass('open')) {
          $(this).attr('aria-expanded', true);
          gsap.to($content, {
            duration: 0.5,
            ease: 'power4.out',
            height: 'auto',
          });
        } else {
          $(this).attr('aria-expanded', false);
          gsap.to($content, { duration: 0.5, ease: 'power4.out', height: 0 });
        }
      });
    });

    const showMoreBtns = $(
      once('show-more-button', '.expanding-cards--show-more', context)
    );
    showMoreBtns.each(function () {
      $(this).on('click', (e) => {
        e.preventDefault();
        let $toggle = $(this);
        let $expandingCards = $toggle.parent().parent();
        $expandingCards.toggleClass('expanded');
        if ($expandingCards.hasClass('expanded')) {
          $toggle.text('Show Less');
          gsap.to($toggle.parent(), {
            duration: 0.5,
            ease: 'power4.out',
            height: 'auto',
          });
        } else {
          $toggle.text('Show More');
          gsap.to($toggle.parent(), {
            duration: 0.5,
            ease: 'power4.out',
            height: 539,
          });
        }
      });
    });
  }
}

DrupalBehavior.register(
  'rush_theme.components',
  'expanding_cards',
  ExpandingCards
);
